import React, { FC, useEffect, useRef } from 'react'
import { Route, RouteProps, Routes } from 'react-router-dom'
import { authentication, AuthenticationStatus } from 'utils'

export const SecureRoute: FC<RouteProps> = ({...routeProps}) => {

    const isLoginPending = useRef(false)
    const authStatus: AuthenticationStatus = authentication.getStatus()

    useEffect(() => {
        const updateAuth = async () => {
            if(authStatus == AuthenticationStatus.Expired) {
                await authentication.renewToken()
            }
            else {
                await authentication.loginWithRedirect()
            }
        }

        if(!isLoginPending.current && authStatus != AuthenticationStatus.Authenticated) {
            isLoginPending.current = true
            updateAuth()
        }
    })

    if(authStatus == AuthenticationStatus.Authenticated) {
        isLoginPending.current = false
    }

    if (authStatus == AuthenticationStatus.Invalid) {
        return null;
    }

    return (
        <Routes>
            <Route { ...routeProps } />
        </Routes>
    )
}